module.exports = "https://coursera_assets.s3.amazonaws.com/images/58a703d6c348aa44fa84fa35b227aa2b.png";